<template>
  <div>
    <v-row class="mb-2">
      <v-col cols="12" sm="6">
        <autocomplete
          v-model="config.settings.week_start"
          :items="weekStartOptions"
          item-text="text"
          item-value="value"
          :label="$t('week_starts_on')"
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'voucher'" class="mb-2">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.quantity_in_period"
          :label="$t('how_many_vouchers_weekly')"
          type="number"
          :hint="$t('number_of_vouchers_available_weekly')"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'order'" class="mb-2">
      <v-col v-if="config.settings.limit_by_quantity" cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_orders"
          :label="$t('how_many_orders_weekly')"
          type="number"
          :hint="$t('max_orders_hint')"
          persistent-hint
        />
      </v-col>
      <v-col v-if="config.settings.limit_by_value" cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_order_value"
          :label="$t('max_order_value')"
          type="number"
          :suffix="restaurantCurrency"
          :hint="$t('max_order_value_hint')"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'credit'" class="mb-2">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_amount"
          :label="$t('credit_amount_weekly')"
          type="number"
          :suffix="restaurantCurrency"
          :hint="$t('credit_amount_renews_weekly')"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'money'" class="mb-2">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.limit_amount"
          :label="$t('money_limit_amount_weekly')"
          type="number"
          :suffix="restaurantCurrency"
          :hint="$t('money_limit_amount_weekly_hint')"
          persistent-hint
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "WeeklyLimitFields",
  props: {
    config: {
      type: Object,
      required: true,
    },
    timingSettings: {
      type: Object,
      required: true,
    },
    activeType: {
      type: String,
      required: true,
    },
  },
  computed: {
    weekStartOptions() {
      return [
        { value: "monday", text: this.$t("monday") },
        { value: "tuesday", text: this.$t("tuesday") },
        { value: "wednesday", text: this.$t("wednesday") },
        { value: "thursday", text: this.$t("thursday") },
        { value: "friday", text: this.$t("friday") },
        { value: "saturday", text: this.$t("saturday") },
        { value: "sunday", text: this.$t("sunday") },
      ];
    },
  },
};
</script>
